/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Next_StepInputs */

const cs_field_next_step = /** @type {(inputs: Field_Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další krok`)
};

const en_field_next_step = /** @type {(inputs: Field_Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next step`)
};

/**
* | output |
* | --- |
* | "Next step" |
*
* @param {Field_Next_StepInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_next_step = /** @type {((inputs?: Field_Next_StepInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Next_StepInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_next_step(inputs)
	return cs_field_next_step(inputs)
});